import { render, staticRenderFns } from "./BallDemo.vue?vue&type=template&id=efc76b26&scoped=true&"
import script from "./BallDemo.vue?vue&type=script&lang=js&"
export * from "./BallDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc76b26",
  null
  
)

export default component.exports